var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Value } from 'slate';
import Html from 'slate-html-serializer';
import parseHtml from '../parseHtml/parseHtml';
import DEFAULT_NODE from '../plugins/DEFAULT_NODE';
export default (function (_a) {
    var createInitialState = _a.createInitialState, plugins = _a.plugins;
    var rules = plugins
        .filter(function (p) { return p.serialize && p.deserialize; })
        .map(function (p) { return ({
        serialize: p.serialize,
        deserialize: p.deserialize,
    }); });
    var html = new Html({
        rules: rules,
        // tslint:disable-next-line:no-any
        parseHtml: parseHtml,
        defaultBlock: DEFAULT_NODE,
    });
    var htmlToSlate = function (htmlString) { return html.deserialize(htmlString); };
    var slateToHtml = function (editorState) { return html.serialize(editorState); };
    var unserialize = function (_a) {
        var importFromHtml = _a.importFromHtml, serialized = _a.serialized, editorState = _a.editorState, rest = __rest(_a, ["importFromHtml", "serialized", "editorState"]);
        if (serialized) {
            // tslint:disable-next-line:no-any
            return __assign({ editorState: Value.fromJSON(serialized) }, rest);
        }
        else if (importFromHtml) {
            return __assign({ editorState: htmlToSlate(importFromHtml) }, rest);
        }
        else if (editorState) {
            return __assign({ editorState: editorState }, rest);
        }
        return __assign(__assign({}, (createInitialState ? createInitialState() : {})), rest);
    };
    // tslint:disable-next-line:no-any
    var serialize = function (_a) {
        var editorState = _a.editorState, rest = __rest(_a, ["editorState"]);
        return (__assign({ 
            // tslint:disable-next-line:no-any
            serialized: editorState.toJSON(editorState) }, rest));
    };
    return {
        serialize: serialize,
        unserialize: unserialize,
        slateToHtml: slateToHtml,
        htmlToSlate: htmlToSlate,
    };
});
//# sourceMappingURL=index.js.map